import React, { useState, useEffect, Fragment } from 'react';
import _ from 'lodash';

import lupa from '../../../../../assets/images/lupaReport.svg';
import seta from '../../../../../assets/images/seta_drop.svg';

/**
 * Component for create the jsx select on the dashboard screen
 *
 * @param {Object[]} options
 */
const SelectDashboardReport = (props) => {
  const {
    options,
    currentDashboard,
    setCurrentDashboard,
    dndState,
    setDndState,
  } = props;

  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [reportSelected, setReportSelected] = useState('');
  const [currentOptions, setCurrentOptions] = useState(options);

  /**
   * Called when the search term change by the user action
   */
  useEffect(() => {
    updateCurrentOptions();
  }, [searchTerm]);

  /**
   * Called when user click on the report name fot show the options for add on the dashboard
   * @param {string} componentName
   */
  const onReportClick = (componentName) => {
    setReportSelected(componentName === reportSelected ? '' : componentName);
  };

  /**
   * Called when the report type (absolute/graphic/custom) is clicked for add on the user custom dashboard
   * @param {Object} option
   */
  const onReportTypeClick = (option) => {
    updateComponentState(option);

    setShowDropdown(!showDropdown);
    setSearchTerm('');
    setReportSelected('');
  };

  /**
   * Called when user change the search term on input
   * @param {Object} event
   */
  const onChangeSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  /**
   * Called when the arrow button on the select input is clicked by user
   */
  const onDropdownArrowClick = () => {
    setShowDropdown(!showDropdown);
  };

  /**
   * Update dndState and currentDashboard objects for add a new component on dashboard
   * @param {Object} option
   */
  const updateComponentState = (option) => {
    const newDndId = getNewDndId();
    const elementId = `element-${newDndId}`;
    const newOption = { ...option, draggableId: elementId };

    updateCurrentDashboard(newOption);
    updateDndState(newOption, elementId);
  };

  /**
   * Change the dnd state value when necessary
   * @param {Object} newOption
   * @param {string} elementId
   */
  const updateDndState = (newOption, elementId) => {
    const newDndElements = { ...dndState.elements };
    const newDndColumns = { ...dndState.columns };

    newDndElements[elementId] = newOption;
    // const columnOne = newDndColumns['column-1'];
    // columnOne.elementsIds = [...columnOne.elementsIds, elementId];
    console.log(newDndColumns['column-1']);
    console.log(dndState.columns);
    newDndColumns['column-1'].elementsIds = [
      ...dndState.columns['column-1'].elementsIds,
      elementId,
    ];

    setDndState({
      ...dndState,
      elements: newDndElements,
      columns: newDndColumns,
    });
  };

  /**
   * Change the current dashboard whe necessary
   * @param {Object} newOption
   */
  const updateCurrentDashboard = (newOption) => {
    const newDashboardElements = [
      ...currentDashboard.dashboardElements,
      newOption,
    ];
    setCurrentDashboard({
      ...currentDashboard,
      showEditOptions: true,
      isEditMode: true,
      dashboardElements: newDashboardElements,
    });
  };

  /**
   * Generate new dnd id for new dashboard element
   * @returns {Number}
   */
  const getNewDndId = () => {
    let count = 0;
    _.forEach(dndState.elements, () => count++);
    return count + 1;
  };

  /**
   * Update the current report options based on the search term
   */
  const updateCurrentOptions = () => {
    const isSearching = searchTerm !== '';
    if (isSearching) {
      formatCurrentOptions();
    } else {
      setCurrentOptions(options);
    }

    setShowDropdown(isSearching);
  };

  /**
   * Format the current report options list based on the search term (only the reports that has topic or subtopic)
   */
  const formatCurrentOptions = () => {
    const filteredCurrentOptions = _.compact(
      _.map(options, (option) => {
        const hasOptionsTitle =
          option.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
        const filteredReports = _.filter(option.reports, (report) => {
          const hasReportTitle =
            report.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;

          if (hasReportTitle) {
            return report;
          }
        });

        if (filteredReports.length > 0) {
          const newOption = _.cloneDeep(option);
          newOption.reports = [...filteredReports];
          return newOption;
        } else {
          if (hasOptionsTitle) {
            return option;
          }
        }
      })
    );

    setCurrentOptions(filteredCurrentOptions);
  };

  /**
   * Render the select input on screen
   */
  const renderDropdownOptions = () => {
    if (showDropdown) {
      return <div className="container-select-comp">{renderTopics()}</div>;
    }
  };

  /**
   * Render topics (bot/ai) for the current option on array
   */
  const renderTopics = () => {
    return _.map(currentOptions, (option) => {
      return (
        <Fragment key={option.id}>
          <p className="mb-10-report">
            <b>{option.title}</b>
          </p>
          {renderSubTopics(option.reports)}
        </Fragment>
      );
    });
  };

  /**
   * Render subtopics (number of clients, number of messages, etc) for the report topics
   * @param {Object[]} reports
   */
  const renderSubTopics = (reports) => {
    return _.map(reports, (report) => {
      return (
        <div key={report.title} className="container-body-select-report">
          <p
            className="mb-10-report"
            onClick={() => onReportClick(report.componentName)}
          >
            {report.title}
          </p>
          <div className="container-select-ab-gf">
            {renderSubTopicsReports(report)}
          </div>
        </div>
      );
    });
  };

  /**
   * Render the types that report has for customize user dashboard
   * @param {Object[]} report
   */
  const renderSubTopicsReports = (report) => {
    if (report.componentName === reportSelected) {
      return _.map(report.options, (option, index) => {
        const style = { fontWeight: 'bold' };
        const margin =
          report.options.length > 1 && index === 0
            ? { ...style, marginRight: 15 }
            : style;
        return (
          <p
            key={index}
            style={margin}
            onClick={() => onReportTypeClick(option)}
          >
            {option.typeText}
          </p>
        );
      });
    }
  };

  return (
    <div className="dv-select-info-dash">
      <div className="container-input-select-reports">
        <div className="container-ipt-img-lupa">
          <img src={lupa} />
          <input
            placeholder="Buscar indicador"
            onChange={onChangeSearch}
            value={searchTerm}
          />
        </div>
        <div className="container-seta-reports" onClick={onDropdownArrowClick}>
          <img src={seta} />
        </div>
      </div>
      {renderDropdownOptions()}
    </div>
  );
};

export default SelectDashboardReport;
